import { render } from "./direccionComponent.vue?vue&type=template&id=ca338ec2"
import script from "./direccionComponent.vue?vue&type=script&lang=js"
export * from "./direccionComponent.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Sendi\\.tools\\sources\\SendiNewClient2.0\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__